<template>
  <div id="navbar-wrapper">
    <NavDrawer 
      :links="getNavbarLinks()"
      :isOpen="drawerIsOpen"
      :isLoggedIn="isLoggedIn"
      :selectedCustomer="selectedCustomer"
    />

    <v-app-bar
      id="nav-app-bar"
      app 
      text 
      dark 
      clipped-left
    >
      <HambugerMenuButton 
        :toggleDrawer="this.toggleDrawer"
      />
      <Title />
      <v-spacer />
      <div>
        <HelpDialog 
          :isLoggedIn="isLoggedIn"
          :isAdmin="showApiKey"
          :tokenString="tokenString"
          :aboutText="aboutText"
        />
        <ProfileListDialog
          :profileListIsOpen="profileListIsOpen"
          :isLoggedIn="isLoggedIn"
          :SignOut="SignOut"
          :displayname="displayname"
          :profileDetails="profileDetails"
        />
        <LoginButton 
          :isLoggedIn="isLoggedIn"
          :v-if="isLoggedIn"
        />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import NavbarLinks from '../../router/NavbarLinks'
import Title from './Title'
import NavDrawer from './NavDrawer'
import HelpDialog from './modals/HelpDialog'
import ProfileListDialog from './modals/ProfileListDialog'
import HambugerMenuButton from './buttons/HamburgerMenuButton'
import LoginButton from './buttons/LoginButton'

export default {
  name: "Navbar",
  components: {
    Title,
    NavDrawer,
    HelpDialog,
    ProfileListDialog,
    LoginButton,
    HambugerMenuButton
  },
  props: {
    displayname: String,
    isLoggedIn: Boolean,
    selectedCustomer: Object,
    app: Object,
    auth: Object,
  },
  watch: {
    isLoggedIn(val) {
      console.log("Navbar::watch isLoggedInd() changed, val:", val);
      this.isLoggedIn = val
      this.drawerIsOpen = this.isLoggedIn;
    },
  },
  data() {
    return {
      drawerIsOpen: false,
      helpIsOpen: false,
      profileIsOpen: false,
      profileListIsOpen: false,
      signoutDialogIsOpen: false,
      showApiKey: false,
    }
  },
  computed: {
    tokenString() {
      return this.app.userProfile?.token ?? '';
    },
    aboutText() {
      return (`
        This web site for use by Qumulex authorized partners only.<br/>
        Updated: ${document.lastModified}<br/>
        &copy; Copyright ${new Date().getFullYear()}, Qumulex, Inc.
      `)
    },
    profileDetails() {
      if(this.app) {
        const { userProfile } = this.app
        return (userProfile && this.isLoggedIn)
          ? (`
            ${userProfile?.firstName} ${userProfile?.lastName}<br/>
            ${userProfile?.email}<br/>
            Role: ${userProfile?.role?.name}<br/>
            Company: ${userProfile?.companyName}<br/>
            Company Id: ${userProfile?.companyId}<br/>
          `)
          : "no logged in user"
      } else return "none"
    }
  },
  beforeUpdate() {
    // before state updates, check if user is admin
    if(this.app?.userProfile?.role?.privileges && this.app?.userProfile?.role?.privileges.includes("sysprep")) {
      this.showApiKey = true
    } else {
      this.showApiKey = false
    }

  },
  methods: {
    toggleDrawer() {
      if(this.isLoggedIn) {
        console.log("drawer toggled")
        this.drawerIsOpen = !this.drawerIsOpen
      }
    },
    getNavbarLinks() {
      if(this.isLoggedIn)
        return NavbarLinks(this.app?.userProfile?.role?.privileges)
    },
    async SignOut() {
      const user = {
        token: this.app.userProfile.token
      }
      await this.auth.SignOut(user, this.app.restApi, this.app.reset);
    },
  }
}
</script>

<style scoped>
#nav-app-bar {
  background-color: rgba(12,18,20,1);
}
</style>